// حمامة سلام احترافية — تدرج بنفسجي/تركوازي
export default function Logo({ size = 96, animated = false, className = '' }) {
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      <svg viewBox="0 0 200 200" width={size} height={size} className={animated ? 'animate-glow' : ''} xmlns="http://www.w3.org/2000/svg">
        <defs>
          {/* Purple to teal gradient for outer body */}
          <linearGradient id="body-grad" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#8b7ff0" />
            <stop offset="45%" stopColor="#a5a5ea" />
            <stop offset="100%" stopColor="#7dd3c3" />
          </linearGradient>
          {/* Wing gradient (softer purple) */}
          <linearGradient id="wing-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#b8afff" />
            <stop offset="100%" stopColor="#8b7ff0" />
          </linearGradient>
          {/* Leaf gradients */}
          <linearGradient id="leaf-a" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#a4d6cc" />
            <stop offset="100%" stopColor="#7dcfa9" />
          </linearGradient>
          <linearGradient id="leaf-b" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#93cec1" />
            <stop offset="100%" stopColor="#5eb2a3" />
          </linearGradient>
          <linearGradient id="leaf-c" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#bde3d9" />
            <stop offset="100%" stopColor="#8fcdba" />
          </linearGradient>
        </defs>

        {/* ============ THREE LEAVES (top-right) ============ */}
        <g transform="translate(115 8)">
          {/* Left small leaf */}
          <path d="M 4 28 C -4 18, -4 6, 4 0 C 12 6, 12 22, 8 30 Z" fill="url(#leaf-a)" />
          {/* Middle tallest leaf */}
          <path d="M 18 30 C 12 14, 18 0, 28 -6 C 32 8, 28 24, 22 32 Z" fill="url(#leaf-b)" />
          {/* Right leaf */}
          <path d="M 34 32 C 34 20, 42 8, 52 6 C 52 20, 44 34, 38 36 Z" fill="url(#leaf-c)" />
          {/* Central white line accent */}
          <path d="M 22 32 Q 24 16 28 0" stroke="#fff" strokeWidth="0.8" fill="none" opacity="0.5" />
        </g>

        {/* ============ OUTER TEARDROP/LEAF BODY ============ */}
        {/* Elegant teardrop that contains the dove */}
        <path d="
          M 108 35
          C 68 38, 40 68, 38 108
          C 36 148, 60 178, 100 182
          C 138 186, 168 158, 172 118
          C 176 78, 152 42, 118 36
          C 114 35, 111 35, 108 35 Z"
          fill="url(#body-grad)" />

        {/* ============ DOVE (white negative space inside) ============ */}
        {/* Dove body: elegant curved silhouette facing right */}
        <path d="
          M 72 100
          C 74 82, 90 72, 108 74
          C 122 76, 132 84, 138 92
          C 144 88, 150 86, 156 84
          C 154 96, 148 106, 138 112
          C 144 122, 142 134, 132 142
          C 120 152, 100 154, 84 148
          C 70 140, 66 122, 68 108
          C 68 105, 70 102, 72 100 Z"
          fill="#fefbf7" />

        {/* Wing (soft purple detail on body) */}
        <path d="
          M 86 116
          C 92 108, 104 108, 114 112
          C 122 116, 124 126, 120 134
          C 114 140, 102 140, 92 136
          C 84 132, 82 122, 86 116 Z"
          fill="url(#wing-grad)" opacity="0.55" />

        {/* Wing feather lines */}
        <path d="M 92 122 L 108 118" stroke="#8b7ff0" strokeWidth="0.8" opacity="0.35" strokeLinecap="round" />
        <path d="M 94 128 L 112 124" stroke="#8b7ff0" strokeWidth="0.8" opacity="0.35" strokeLinecap="round" />

        {/* Peaceful closed eye (curved arc) */}
        <path d="M 128 90 Q 133 93 138 90" stroke="#6a5cd8" strokeWidth="2" fill="none" strokeLinecap="round" />

        {/* Small beak */}
        <path d="M 146 92 L 156 94 L 148 98 Z" fill="#e5b872" opacity="0.9" />

        {/* Subtle body highlight */}
        <ellipse cx="90" cy="90" rx="14" ry="22" fill="#fff" opacity="0.35" />

        {/* Bottom shine */}
        <ellipse cx="68" cy="150" rx="18" ry="6" fill="#fff" opacity="0.15" />
      </svg>
    </div>
  );
}

// Mini logo for headers
export function LogoMini({ size = 40, className = '' }) {
  return (
    <div className={`rounded-2xl overflow-hidden shadow-md relative ${className}`}
         style={{ width: size, height: size, background: 'linear-gradient(135deg, #b8afff 0%, #a5a5ea 45%, #7dd3c3 100%)' }}>
      <svg viewBox="0 0 100 100" width={size} height={size} xmlns="http://www.w3.org/2000/svg">
        {/* Leaves at top-right */}
        <g transform="translate(58 8)">
          <path d="M 2 14 C -2 8, -2 2, 2 -2 C 6 2, 6 10, 4 16 Z" fill="rgba(255,255,255,0.85)" />
          <path d="M 10 16 C 7 8, 10 0, 14 -3 C 16 4, 14 12, 12 18 Z" fill="rgba(255,255,255,0.95)" />
          <path d="M 18 18 C 18 10, 22 4, 27 2 C 27 12, 22 20, 20 22 Z" fill="rgba(255,255,255,0.8)" />
        </g>
        {/* Dove silhouette */}
        <path d="M 30 50 C 32 40, 42 34, 55 36 C 65 38, 71 42, 74 48 C 78 46, 82 44, 84 44 C 82 52, 78 58, 72 62 C 76 68, 74 76, 68 80 C 62 84, 50 84, 42 82 C 34 78, 30 68, 30 58 C 30 55, 30 52, 30 50 Z" fill="#fefbf7" />
        {/* Wing */}
        <path d="M 40 62 C 44 58, 52 58, 58 62 C 62 66, 62 72, 58 74 C 52 76, 46 74, 42 70 C 39 67, 39 64, 40 62 Z" fill="#8b7ff0" opacity="0.5" />
        {/* Eye */}
        <path d="M 67 50 Q 71 52 74 50" stroke="#6a5cd8" strokeWidth="1.4" fill="none" strokeLinecap="round" />
        {/* Beak */}
        <path d="M 78 51 L 84 52 L 79 55 Z" fill="#e5b872" opacity="0.85" />
      </svg>
    </div>
  );
}

// Wordmark: logo + “سلام” + tagline
export function LogoWordmark({ size = 100, showTagline = true }) {
  return (
    <div className="flex flex-col items-center gap-3">
      <Logo size={size} animated />
      <div className="text-center">
        <h1 className="font-extrabold"
            style={{ fontSize: `${Math.max(size * 0.46, 44)}px`, letterSpacing: '-0.02em', lineHeight: 1,
              background: 'linear-gradient(135deg, #8b7ff0 0%, #6a5cd8 50%, #5eb2a3 100%)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text', color: 'transparent',
              fontFamily: "'Cairo', 'Tajawal', sans-serif" }}>
          سلام
        </h1>
        {showTagline && (
          <div className="mt-2 flex items-center justify-center gap-2">
            <div className="w-1 h-1 rounded-full" style={{ background: '#5eb2a3' }}></div>
            <p className="text-[13px] font-semibold" style={{ color: '#6b6480' }}>سلام… لأن الطمأنينة حقّ لك.</p>
            <div className="w-1 h-1 rounded-full" style={{ background: '#5eb2a3' }}></div>
          </div>
        )}
      </div>
    </div>
  );
}
